<template>
    <div class="version2-bottom-middle">
        <div class="version2-bottom-middle-block">
            <CollageTotal></CollageTotal>
            <Inventor></Inventor>
        </div>
    </div>
</template>
<script>
import CollageTotal from './collageTotal.vue'
import Inventor from './inventor.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    CollageTotal,
    Inventor
  }
}
</script>
